import { defineStore } from 'pinia'
import tinycolor from "tinycolor2";

export const useBrandingStore = defineStore('branding', {
    state: () => ({
        brandPrimary: '',
        brandSecondary: '',
        systemError: '',
        systemWarning: '',
        systemSuccess: '',
        black: '',
        logoBigUrl: '',
        logoCompactUrl: '',
    }),
    actions: {
        load(data) {
            this.brandPrimary = data.brandingPrimary;
            this.brandSecondary = data.brandingSecondary;
            this.systemError = data.systemError;
            this.systemWarning = data.systemWarning;
            this.systemSuccess = data.systemSuccess;
            this.black = data.black;
            this.logoBigUrl = data.bigLogo;
            this.logoCompactUrl = data.compactLogo;
        },
    },
    getters: {
        brandPrimaryLight: (state) => calculateLighten(state.brandPrimary, 10),
        brandPrimaryDark: (state) => calculateDarken(state.brandPrimary),
        brandSecondaryLight: (state) => calculateLighten(state.brandSecondary, 10),
        brandSecondaryDark: (state) => calculateDarken(state.brandSecondary),
        gray600: (state) => calculateLighten(state.black, 74),
        gray400: (state) => calculateLighten(state.black, 36),
        gray300: (state) => calculateLighten(state.black, 24),
        gray200: (state) => calculateLighten(state.black, 12),
        gray100: (state) => calculateLighten(state.black, 8),
        gray50: (state) => calculateLighten(state.black, 4),
        systemErrorDark: (state) => calculateDarken(state.systemError),
        systemWarningDark: (state) => calculateDarken(state.systemWarning),
        systemSuccessLight: (state) => calculateLighten(state.systemSuccess, 20),
        systemSuccessDark: (state) => calculateDarken(state.systemSuccess),
        systemErrorLight: (state) => calculateLighten(state.systemError, 20),
    }
})

function calculateDarken(color) {
    return (
        "#" +
        tinycolor
        .mix(
            tinycolor(
            "rgb " +
                Math.floor(
                (tinycolor(color).toRgb().r * tinycolor(color).toRgb().r) / 255
                ) +
                " " +
                Math.floor(
                (tinycolor(color).toRgb().g * tinycolor(color).toRgb().g) / 255
                ) +
                " " +
                Math.floor(
                (tinycolor(color).toRgb().b * tinycolor(color).toRgb().b) / 255
                )
            ),
            color,
            25
        )
        .toHex()
    );
}

function calculateLighten(color, amount) {
    return "#" + tinycolor.mix(tinycolor("#ffffff"), color, amount).toHex();
}